export default {
  "app.dashboard.analysis.timeLabel": "時間",
  "component.globalHeader.notification": "通知",
  "component.globalHeader.notification.empty": "全ての通知を見ました",
  "component.globalHeader.message": "メッセージ",
  "component.globalHeader.message.empty": "全てのメッセージを読みました",
  "component.globalHeader.event": "予定",
  "component.globalHeader.event.empty": "全ての予定を完了しました",
  "component.globalHeader.warn": "警告",
  "component.globalHeader.warn.empty": "全ての警告を読みました",
  "component.noticeIcon.clear": "クリア",
  "component.noticeIcon.cleared": "クリアされました",
  "component.noticeIcon.empty": "データなし",
  "component.noticeIcon.view-more": "もっと見る",
  "app.device.summary.listLabel": "製品リスト",
  "DeviceList.deviceid": "デバイスID",
  "DeviceList.battery": "電池",
  "DeviceList.signal": "信号",
  "DeviceList.step": "歩数",
  "DeviceList.distance": "距離(メートル)",
  "DeviceList.calorie": "カロリー(カロリー)",
  "DeviceList.model": "デバイスモデル",
  "DeviceList.clientid": "クライアントID",
  "DeviceList.viewdata": "表示",
  "DeviceList.group.mesage": "グループメッセージ",
  "DeviceList.action": "アクション",
  "User.logout": "ログアウト",
  "DeviceSummary.baseinfo": "基本情報",
  "DeviceSummary.watchname": "4G健康ウォッチ",
  "DeviceSummary.blewatchname": "ブルートゥース健康ウォッチ",
  "DeviceSummary.deviceinfo": "デバイス情報",
  "DeviceSummary.datasync": "一括アップロード",
  "DeviceSummary.summary": "概要",
  "DeviceSummary.hr": "心拍数",
  "DeviceSummary.rri": "不整脈",
  "DeviceSummary.ecg": "心電図",
  "DeviceSummary.sport": "運動",
  "DeviceSummary.sleep": "睡眠",
  "DeviceSummary.gnss": "位置情報",
  "DeviceSummary.male": "男性",
  "DeviceSummary.female": "女性",
  "DeviceSummary.gender": "性別",
  "DeviceSummary.height": "身長",
  "DeviceSummary.no": "なし",
  "DeviceSummary.weight": "体重",
  "DeviceSummary.birthday": "誕生日",
  "DeviceSummary.imei": "デバイス番号",
  "DeviceSummary.online": "オンライン",
  "DeviceSummary.offline": "オフライン",
  "DeviceSummary.edit": "編集",
  "DeviceSummary.nickname": "ニックネーム",
  "DeviceSummary.target.step": "目標歩数",
  "DeviceSummary.target.calorie": "目標カロリー",
  "DeviceSummary.save": "保存",
  "DeviceSummary.cancel": "キャンセル",
  "DeviceSummary.nickname.input": "ニックネームを入力してください",
  "DeviceSummary.gender.input": "性別を選択してください",
  "DeviceSummary.height.input": "身長を入力してください",
  "DeviceSummary.weight.input": "体重を入力してください",
  "DeviceSummary.birthday.input": "誕生日を入力してください",
  "DeviceSummary.target_step.input": "目標歩数を入力してください",
  "DeviceSummary.target_calorie.input": "目標カロリーを入力してください",
  "DeviceSummary.resetdevice": "工場設定にリセット",
  "DeviceSummary.resetdevice.notice":
    "デバイスのユーザー情報が削除され、デバイスが工場設定に戻ります。本当によろしいですか？",
  "DeviceSummary.binded": "バインド済み",
  "DeviceSummary.day": "日",
  "DeviceSummary.wear": "着用",
  "IwownAi.aislogan":
    "私はマイクロソフトのチャットボットです、質問してください",
  "IwownAi.aifailed": "申し訳ありません、理解できませんでした…",
  "IwownAi.hint": "質問を入力してください...",
  "IwownAi.send": "送信",
  "HealthHome.pagetitle": "データ概要",
  "HealthHome.hr": "心拍数",
  "HealthHome.rri": "不整脈",
  "HealthHome.step": "歩数",
  "HealthHome.sleep": "睡眠",
  "HealthHome.ecg": "心電図",
  "HealthHome.position": "位置情報",
  "HealthHome.hours": "時間",
  "HealthHome.minutes": "分",
  "HeartRate.abnormal": "異常な心拍数",
  "HeartRate.avghr": "平均心拍数",
  "HeartRate.maxhr": "最大心拍数",
  "HeartRate.minhr": "最小心拍数",
  "HeartRate.avgsporthr": "平均運動心拍数",
  "HeartRate.sporthr": "運動心拍数",
  "HeartRate.minutes": "分",
  "HeartRate.range_normal": "通常",
  "HeartRate.range_warmup": "ウォームアップ",
  "HeartRate.range_burnfat": "脂肪燃焼",
  "HeartRate.range_aerobic": "有酸素運動",
  "HeartRate.range_anaerobic": "無酸素運動",
  "HeartRate.range_extreme": "極限",
  "AtrialData.afdata": "心臓健康",
  "AtrialData.today24hours": "今日の24時間",
  "AtrialData.dateselect": "日付を選択",
  "AtrialData.diagnosis": "診断結果",
  "AtrialData.disclaimer":
    "注意: 医療診断ではありません。参考までにしてください。病院の診断を優先してください。",
  "AtrialData.chart_title": "散布図",
  "AtrialData.nodata": "不整脈データがありません",
  "AtrialData.normal": "不整脈は検出されていません。",
  "AtrialData.abnormal": "不整脈の可能性があります。",
  "AtrialData.noresult": "結果なし、干渉または異常なデータがあります。",
  "AtrialData.SINUS_HR": "正常な心拍。",
  "AtrialData.SINUS_BRADYCARDIA": "心拍数が遅い。",
  "AtrialData.SINUS_TACHYCARDIA": "心拍数が速い。",
  "AtrialData.SINUS_ARRHYTHMIA": "不整脈(早発)。",
  "AtrialData.SINUS_ATRIAL_FIBRILLATION": "不整脈。",
  "AtrialData.SINUS_SUPRAVENTRICULAR_TACHYCARDIA": "速い心拍数(上室性頻拍)。",
  "AtrialData.timebar_title": "最近24時間の不整脈分/時間",
  "AtrialData.hrbar_title": "最近24時間の心拍数曲線",
  "AtrialData.afchart_title": "最近7日間の不整脈疑い時間/日の有効測定時間",
  "AtrialData.measure_time": "測定時間",
  "AtrialData.aftime": "不整脈時間",
  "AtrialData.time": "時間",
  "AtrialData.scatter.desc":
    "散布図: 非線形カオス理論に基づき、コンピュータの高速演算技術を活用して、長期RR間隔データをグラフィカルに表現し、心拍変動を分析します。",
  "EcgView.title": "心電波形",
  "EcgView.ecgdatalist": "心電データリスト",
  "EcgView.normal": "正常",
  "EcgView.SINUS.HR": "洞調律",
  "EcgView.SINUS.BRADYCARDIA": "洞調律の疑い（徐脈）",
  "EcgView.SINUS.TACHYCARDIA": "洞調律の疑い（頻脈）",
  "EcgView.SINUS.ARRHYTHMIA": "洞調律の不整脈の疑い（早期収縮）",
  "EcgView.SINUS.ATRIAL.FIBRILLATION": "洞調律の不整脈の疑い（不整脈）",
  "EcgView.SINUS.NOResult": "AIによる解析結果なし",
  "EcgView.loading": "データ読み込み中...",
  "EcgView.note": "ユーザーメモ",
  "EcgView.diagnosis": "診断結果",
  "EcgView.disclaimer":
    "注: 上記の診断は、人工知能診断アルゴリズムCardiolearnによって提供されたものであり、参考のためのものです。正確な診断には、医療機関での診断をお勧めします。",
  "EcgView.today": "今日",
  "EcgView.sevenday": "過去7日間",
  "EcgView.onemonth": "過去30日間",
  "EcgView.ecgtime": "測定時間",
  "EcgView.ai_result": "分析結果",
  "Sports.title": "運動",
  "Sports.step": "歩数",
  "Sports.meter": "メートル",
  "Sports.minute": "分",
  "Sports.unit": "単位",
  "Sports.datalist": "運動データリスト",
  "Sports.step.title": "運動歩数",
  "Sports.distance.title": "運動距離",
  "Sports.duration.title": "運動時間",
  "Sports.startime.title": "開始時間",
  "Sports.sportype.title": "運動種類",
  "Sleep.title": "睡眠",
  "Sleep.hour": "時間",
  "Sleep.minute": "分",
  "Sleep.score": "スコア",
  "Sleep.bless": "良い睡眠習慣を維持しましょう!",
  "Sleep.light": "浅い睡眠",
  "Sleep.deep": "深い睡眠",
  "Sleep.awake": "覚醒",
  "Sleep.rem": "レム睡眠",
  "Sleep.benchmark": "基準値: 10%-40%",
  "Sleep.score.prefix": "睡眠スコアは",
  "Sleep.value.high": "高い",
  "Sleep.value.low": "低い",
  "Sleep.value.normal": "正常",
  "Sleep.light_desc":
    "浅い睡眠は、全睡眠時間の約65%を占める軽度の睡眠段階です。この段階では、筋肉がさらにリラックスし、脳波はソー波を示します。",
  "Sleep.deep_desc":
    "深い睡眠は「ゴールデンスリープ」とも呼ばれ、全睡眠時間の約25%を占めます。大脳皮質の細胞は完全に休息状態にあり、疲労の回復やエネルギーの再生、免疫力の向上に役立ちます。",
  "Sleep.awake_desc":
    "理想的な睡眠は、毎晩7～9時間であり、これが睡眠の質を保証します。良い睡眠習慣を維持し、睡眠の自然なリズムに従うことが、覚醒時間を減らす最良の方法です。",
  "Sleep.rem_desc":
    "レム睡眠は、正常な睡眠周期の一部であり、「急速眼球運動」期とも呼ばれます。この段階では、眼球が急速に動き、筋肉がリラックスして一時的な麻痺状態になります。",
  "Auth.Login.failed.title": "ログイン失敗",
  "Auth.Login.failed.desc": "アカウントとパスワードを確認してください",
  "Auth.site.desc":
    "Watch Centerは、4Gスマートウォッチのデータの表示プラットフォームです。",
  "Auth.username": "ユーザー名",
  "Auth.username.prompt": "ユーザー名を入力してください!",
  "Auth.password": "パスワード",
  "Auth.password.prompt": "パスワードを入力してください!",
  "Auth.autologin": "自動ログイン",
  "Auth.login": "ログイン",
  "Auth.login.method.account": "アカウントパスワードでログイン",
  "OverView.listview.title": "デバイス番号",
  "Menu.dashboard": "ダッシュボード",
  "Menu.Monitor": "モニタリングページ",
  "Menu.Robot": "ロボット",
  "Menu.Device": "デバイス",
  "Menu.DeviceList": "デバイスリスト",
  "DeviceSetting.Setting": "デバイス設定",
  "DeviceSetting.Notification.Title": "良いニュース",
  "common.save.succeed": "情報の保存に成功しました",
  "common.save.failed": "情報の保存に失敗しました",
  "Export.button.name": "ファイル",
  "Export.Base.title": "基本情報",
  "Export.Base.nickname": "お名前",
  "Export.Base.deviceId": "デバイスID",
  "Export.Base.date": "日付",
  "Export.Base.details": "明細データ",
  "Export.Base.times": "時間",
  "Export.Sleep.title": "睡眠小結",
  "Export.Sleep.total": "総睡眠時間",
  "Export.Sleep.start": "就寝時間",
  "Export.Sleep.end": "起床時間",
  "Export.Sleep.deep": "深い睡眠時間",
  "Export.Sleep.light": "浅い睡眠時間",
  "Export.Sleep.rem": "REM時間",
  "Export.Sleep.wake": "覚醒時間",
  "Export.Sleep.cycle": "周期",
  "Export.Sleep.duration": "時間",
  "Export.Heart.hr": "心拍",
  "Export.Step.step": "ステップ数",
};
